export default __webpack_public_path__ + "static/media/9.1f5aa17f.jpg";